const articleTracker = {
    en: {
    articleTracker: {
        title:"Article Tracker",
        form: {
          search: "Search",
          dateFilter: "Filter by Date",
          export: "Export",
          noMatch: "Oops! No projects matched your search.",
          maxError: "Maximum of {max} urls per search",
          wrongFormat: "Each URL must either begin with http:// OR https://",
          toCorrect: "Please correct the below:",
          articlesSearchInput: "URLS to Debug",
          articlesSearchResult: "Display Results",
          multiselectEmpty:"Type project name",
          client:"client: ",
          clientId:"client id: ",
          projectId:"project id:",
          projectLabel: "Filter by Project"
        },
        trackerTable:{
          variants:"URL",
          bodhiIds:"Bodhi IDs",
          insightIds:"Insight IDs",
          crawlerIds:"Crawler IDs",
          notFound:"Not Found",
          createdAt:"Created At",
          publishedAt:"Published At",
          variantUrls : "Urls",
          allVariants: "Variant URLs",
          noMatch: "- NOT A MATCH",
          provider: "Provider",
          articlesFound: "Articles",
          manualUpload: "Manual Upload",
          lexisNexis: "Lexis Nexis Manual",
          displayFilter:{
            all: "All",
            found: "Found",
            notFound: "Not Found",
            exactMatch: "URL Exact Match"
          }
        }
      }
    }
  }
  
  module.exports.articleTracker = articleTracker;